export default function initVideoplayers() {
  document.querySelectorAll('.video-container').forEach((video) => {
    video.addEventListener('click', (e) => {
      e.preventDefault();
      if (video.classList.contains('is-playing')) {
        video.classList.remove('is-playing');
        video.querySelector('video').pause();
      } else {
        video.classList.add('is-playing');
        video.querySelector('video').play();
      }
    });
  });
}
